import {connect} from '@modifi/redux'
import {aCloseDialog} from '@modifi/plugin-dialogs'
import {getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'
import {BuyerRegistrationSearchDialog} from '@modifi/plugin-onboarding'

import {
  aFetchRegistrationTypesByCountryCode,
  selectRegistrationTypesByCountryCode,
} from '../../../../data/registration-types'

const apiClient = getAuthenticatedThemisClient()

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: Record<string, any>, ownProps: any) => {
  const {selectedCountryCode} = ownProps?.params
  return {
    registrationTypes: selectRegistrationTypesByCountryCode(state, selectedCountryCode),
    onSearch: (registrationType: string, country: string, registrationNumber: string): any =>
      apiClient.PublicRegisteredCompanies.search({
        registrationType,
        countryCode: country,
        registrationNumber,
      })
        .then(res => res.data()?.companies || [])
        .then(companies =>
          companies?.map(company => ({
            address: company?.company?.address,
            companyName: company?.company?.companyName,
            companyIds: company?.companyIds,
            legalForm: company?.company?.legalForm,
            website: company?.company?.website,
          }))
        ),
  }
}

const mapDispatchToProps = {
  closeDialog: aCloseDialog,
  fetchRegistrationTypes: aFetchRegistrationTypesByCountryCode,
}

export const DIALOG_NAME = 'seller-trade-partner/buyer-registration-search'

export default connect(mapStateToProps, mapDispatchToProps)(BuyerRegistrationSearchDialog)
